import React, { Component } from 'react';
import {
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import './OnBoardingComponent1.css';

class OnBoardingComponent1 extends Component {

  render() {

    return <div id="ob1">
      <Row style={{ height: '97vh', justifyContent: 'center', alignItems:'center' }} className="padding-left-13 height-100">
        <Col>
          <div className="vert-align">
            <div className="text-align-center margin-top-20">
              <span className="page-title">Welcome to the brand new</span>
              <br />
              <br />
              <Card style={{ padding: '12px 50px', width: '680px' }}>
                <CardBody>
                  <img src="images/logo.png" height="226px" alt="" />
                  <div className="top-highlights"> Top highlights of <span className="jkbaadshah-txt">JK BAADSHAH 2.0</span></div>
                </CardBody>
              </Card>
              <br />
            </div>
          </div>
        </Col>
      </Row>
    </div >;
  }
}

export default OnBoardingComponent1;